import React, { useState } from 'react'
import { CreateMapModalProps } from './types'
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Title,
  CloseButton,
  Form,
  FormGroup,
  Label,
  Input,
  TextArea,
  ButtonGroup,
  Button,
} from './styled'

const CreateMapModal: React.FC<CreateMapModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)

  if (!isOpen) return null

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return

    setLoading(true)
    try {
      await onSubmit({ name: name.trim(), description: description.trim() })
      setName('')
      setDescription('')
      onClose()
    } catch (error) {
      console.error('Error creating map:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    if (!loading) {
      setName('')
      setDescription('')
      onClose()
    }
  }

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <Title>Create New Map</Title>
          <CloseButton onClick={handleClose} disabled={loading}>
            ×
          </CloseButton>
        </ModalHeader>

        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="map-name">Map Name</Label>
            <Input
              id="map-name"
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter map name"
              required
              disabled={loading}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="map-description">Description (optional)</Label>
            <TextArea
              id="map-description"
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Enter map description"
              disabled={loading}
            />
          </FormGroup>

          <ButtonGroup>
            <Button type="button" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={loading || !name.trim()}>
              {loading ? 'Creating...' : 'Create Map'}
            </Button>
          </ButtonGroup>
        </Form>
      </ModalContent>
    </ModalOverlay>
  )
}

export { CreateMapModal }
